import { Field, Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import * as Yup from "yup";
import user from "../../assets/images/icons/user.svg";
// images
import footerBg from "../../assets/images/footer.0cdf0088.webp";
import email from "../../assets/images/icons/email.svg";
import eye_visible from "../../assets/images/icons/eye_visible.svg";
import eye_Invisible from "../../assets/images/icons/eye_Invisible.svg";
import footerImage from "../../assets/images/sn_16299738424454.webp";
import { signupAction } from "../../containers/signup/actions";
import TextInput from "../formfields/InputField";
import { getOldHomeData } from "../../containers/home/actions";
import "./style.scss";
import ReCAPTCHA from "react-google-recaptcha";
import { Card, Col, Container, Row } from "react-bootstrap";
import { regex } from "../../utils/regex";
import { fetchCaptchaResponse } from "../../utils/request";
import CustomButton from "../Buttons/CustomButton";
import { convertSpaceToHyphen } from "../../utils/commonFunctions";

const validationSchema = Yup.object({
  email: Yup.string()
    .required("Email can not be empty")
    .email("Email must be a valid email address")
    .matches(regex.email, "Email must be a valid email address"),
  fname: Yup.string().required("First Name can not be empty"),
  lname: Yup.string().required("Last Name can not be empty"),
  password: Yup.string()
    .required("Password can not be empty")
    .matches(regex.password, "Password must include minimum 8 characters with one uppercase, one special character and one numeric value."),
  reEnter_password: Yup.string()
    .required("Confirm Password can not be empty")
    .oneOf([Yup.ref("password"), null], "Password does not match"),
  accept_terms: Yup.bool().required("Please accept the BAA and Terms of Use.").oneOf([true], "Please accept the BAA and Terms of Use."),
});

const Footer = (props) => {
  const [ipAddress, getIpAddress] = useState("");
  const [showError, setShowError] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const cookie = new Cookies();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    show_pass: false,
    con_pass: false,
  });
  const initialState = {
    fname: "",
    lname: "",
    email: "",
    password: "",
    reEnter_password: "",
    accept_terms: false,
  };
  useEffect(() => {
    dispatch(getOldHomeData());
  }, []);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        getIpAddress(res.ip);
      })
      .catch((err) => console.error("Problem fetching my IP", err));
  }, []);
  const handleSubmit = (values, actions) => {
    if (!isCaptchaVerified) {
      setShowError(true);
      return;
    }
    const data = {
      fname: values.fname,
      lname: values.lname,
      email: values.email,
      password: values.password,
      accept_terms: values.accept_terms,
      ip: ipAddress,
    };
    data.type = "join-free";
    props.signupAction(data, actions, props.history);
  };

  const errorHandler = (values) => {
    if (!values.accept_terms) {
      setShowError(true);
    }
  };

  const verifyCaptcha = useCallback(async (token) => {
    if (!token) {
      setIsCaptchaVerified(false);
      return;
    }
    const data = await fetchCaptchaResponse(token);
    if (data?.status) {
      setIsCaptchaVerified(true);
    }
  }, []);

  const handleClickTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <section
      style={{ background: `url(${footerBg}) no-repeat center center / cover` }}
      className={`footerArea ${!cookie.get("user_token") ? "" : "footerAreaMiddle"}`}
    >
      <Container>
        <Row>
          <Col lg={6}>
            <h1 className="text-white">{!cookie.get("user_token") ? props.home_data?.community_title : "Practice with peace of mind"}</h1>
            <p className="text-xxl text-white">{!cookie.get("user_token") ? props.home_data?.community_sub_title : null}</p>
            {!cookie.get("user_token") ? null : (
              <Link onClick={handleClickTop} to="/resources">
                <CustomButton variant="insurance" type="submit" gradient>
                  Explore Resources
                </CustomButton>
              </Link>
            )}
            {!cookie.get("user_token") ? (
              <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ values, handleChange, handleBlur, errors }) => {
                  return (
                    <Form className="">
                      <Card className="my-xl-5 my-4">
                        <Card.Body className="p-4 p-lg-5">
                          <Field
                            id="fname"
                            name="fname"
                            component={TextInput}
                            value={values.fname}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="First Name*"
                            icons={user}
                            iconClass="fa-user"
                            className="mb-3"
                          />
                          <Field
                            id="lname"
                            name="lname"
                            component={TextInput}
                            value={values.lname}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Last Name*"
                            icons={user}
                            iconClass="fa-user"
                            className="mb-3"
                          />
                          <Field
                            id="email"
                            name="email"
                            component={TextInput}
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="E-mail*"
                            icons={email}
                            className="mb-3"
                          />
                          <Field
                            id="password"
                            name="password"
                            component={TextInput}
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Choose Password*"
                            icons={!state.con_pass ? eye_visible : eye_Invisible}
                            iconClass={!state.show_pass ? "fa-eye" : "fa-eye-slash"}
                            type={state.show_pass ? "text" : "password"}
                            className="mb-3"
                            showPassHandler={() =>
                              setState({
                                ...state,
                                show_pass: !state.show_pass,
                              })
                            }
                            maxLength={25}
                          />
                          <Field
                            id="reEnter_password"
                            name="reEnter_password"
                            component={TextInput}
                            value={values.reEnter_password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Re-enter Password*"
                            icons={!state.con_pass ? eye_visible : eye_Invisible}
                            iconClass={!state.con_pass ? "fa-eye" : "fa-eye-slash"}
                            type={state.con_pass ? "text" : "password"}
                            className="mb-3"
                            showPassHandler={() =>
                              setState({
                                ...state,
                                con_pass: !state.con_pass,
                              })
                            }
                            maxLength={25}
                          />
                          <div className="mt-3">
                            <div className="form-check">
                              <Field
                                type="checkbox"
                                className="form-check-input"
                                id="accept_terms"
                                name="accept_terms"
                                onChange={handleChange}
                                checked={values.accept_terms}
                                style={{
                                  backgroundColor: values.accept_terms === true ? "rgb(122, 219, 209)" : "transparent",
                                  borderColor: "rgb(122, 219, 209)",
                                }}
                              />
                              <label className="form-check-label cursor-pointer" htmlFor="accept_terms">
                                I agree to the{" "}
                                <a
                                  style={{
                                    color: "rgb(122, 219, 209)",
                                    textDecoration: "none",
                                  }}
                                  href="/business-associate-agreement"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  BAA
                                </a>{" "}
                                and{" "}
                                <a
                                  style={{
                                    color: "rgb(122, 219, 209)",
                                    textDecoration: "none",
                                  }}
                                  href="/terms-of-service"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  Terms of Use.
                                </a>
                              </label>
                            </div>
                            {showError && <div style={{ color: "#b00020" }}>{errors.accept_terms}</div>}
                          </div>
                          <div className="mt-3">
                            <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY || ""} onChange={verifyCaptcha} />
                            {showError && !isCaptchaVerified && <div style={{ color: "#b00020" }}>Please enter valid reCAPTCHA</div>}
                          </div>
                        </Card.Body>
                      </Card>

                      <div className="d-flex align-items-center justify-content-between">
                        <CustomButton variant="insurance" type="submit" gradient onClick={() => errorHandler(values)}>
                          Join Now For Free
                        </CustomButton>
                        <a
                          className="forgotPassword"
                          style={{ color: "white", float: "right", textDecoration: "none" }}
                          href={`/login`}
                          aria-label="Already a member? Log In"
                        >
                          Already a member? <u>Log in</u>
                        </a>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            ) : null}
          </Col>
        </Row>
      </Container>
      <div className="footerImg d-none d-lg-block">
        {props.home_data?.is_video === "Yes" && <video className="video" autoPlay loop src={props.home_data?.community_video}></video>}
        {props.home_data?.is_video === "No" && <img className="image" src={footerImage} alt={`${convertSpaceToHyphen(props.home_data?.community_title)}-clarity-cooperative`} />}

        {/* <Link to="/signup" className="scrollBtn footerJoinNow d-block d-lg-none" onClick={handleClickTop}>
              <img className="scrollText" src={joinNow} alt="text" />
              <img className="angleText" src={joinArrow} alt="angle" />
            </Link> */}
      </div>
      {/* <Link to="/signup" onClick={handleClickTop} className="scrollBtn footerJoinNow d-none d-lg-block">
        <img className="scrollText" src={joinNow} alt="text" />
        <img className="angleText" src={joinArrow} alt="angle" />
      </Link> */}
    </section>
  );
};

const mapStateToProps = (state) => ({
  home_data: state.home.old_home_data,
});

export default connect(mapStateToProps, { signupAction })(withRouter(Footer));
